import classNames from 'classnames/bind';
import { IFlightSearchHistory, useSearchHistories } from 'hooks/useHistory';
import { useState } from 'react';
import SubSchedule from './SubSchedule';
import styles from './index.module.scss';

const cx = classNames.bind(styles);
export const SEARCH_HISTORY_COUNT = 3;

export interface GroupedSearchHistory {
  tripListCityCode: string;
  tripListCityName: string;
  histories: IFlightSearchHistory[];
}

/**
 * 검색 기록을 출도착지 도시 단위로 묶어서 반환하는 함수
 * @param histories 유저의 검색 기록
 * @returns 출도착지 도시 단위 단위로 묶어서 반환한 결과
 */
const groupHistoriesByTripList = (histories: IFlightSearchHistory[]) => {
  const groupedHistories: GroupedSearchHistory[] = [];

  histories.forEach(history => {
    const tripListCityCode = history.tripList
      .map(trip => `${trip.departureCityCode}-${trip.destinationCityCode}`)
      .join('|');

    const tripListCityName = history.tripList
      .map(trip => `${trip.departureCityName}-${trip.destinationCityName}`)
      .join('|');

    let group = groupedHistories.find(
      g => g.tripListCityCode === tripListCityCode,
    );

    if (!group) {
      group = { tripListCityCode, tripListCityName, histories: [] };
      groupedHistories.push(group);
    }

    group.histories.push(history);
  });

  return groupedHistories;
};

export const generateRedirectUrlFromHistory = (
  history: IFlightSearchHistory,
) => {
  const { tripList, passenger, fareType, isDirect } = history;
  const { adult, child, infant } = passenger;
  const isDomestic =
    tripList.length <= 2 &&
    tripList.reduce(
      (acc, cur) => acc && cur.isDomesticDeparture && cur.isDomesticDestination,
      true,
    );
  const url = tripList.reduce(
    (acc, cur) =>
      acc +
      `/${cur.departureCityCode}-${cur.destinationCityCode}-${cur.departureDate}`,
    '',
  );

  return `/flights/${
    isDomestic ? 'domestic' : 'international'
  }${url}?${new URLSearchParams({
    adult,
    child,
    infant,
    isDirect,
    fareType,
  } as unknown as Record<string, string>).toString()}`;
};

export default function RecentlySearched() {
  const [isExpanded, setIsExpanded] = useState(true);
  const { data } = useSearchHistories(SEARCH_HISTORY_COUNT);

  if (!data || data?.searchHistories?.length < 1) {
    return null;
  }

  const { searchHistories } = data;
  const groupedHistories = groupHistoriesByTripList(searchHistories);

  return (
    <section className={cx('RecentlySearched')}>
      <button
        aria-expanded={isExpanded}
        className={cx('title')}
        data-event-nlog="click"
        data-event-area-code="arr.recentmore"
        type="button"
        onClick={() => setIsExpanded(prev => !prev)}
      >
        최근검색
      </button>
      {isExpanded && (
        <ul className={cx('search_list')}>
          {groupedHistories.map((groupedHistory, index) => (
            <SubSchedule key={index} index={index} history={groupedHistory} />
          ))}
        </ul>
      )}
    </section>
  );
}
